import React, { FC } from 'react'

import { WithDataName } from 'common/types'

import { Mute } from '../photoStatus/PhotoStatus'
import { MuteContactSvg } from '../svg/MuteContactSvg'

export const ProfileMute: FC<WithDataName> = ({ ...rest }) => {
  const dataName = rest['data-name'] ? rest['data-name'] : 'mute-status'

  return (
    <Mute data-name={dataName}>
      <MuteContactSvg />
    </Mute>
  )
}
